/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const postApiProjectpriorities200Schema = z.any();

export const postApiProjectprioritiesMutationRequestSchema = z.object({
  name: z.coerce.string(),
});

export const postApiProjectprioritiesMutationResponseSchema = z.lazy(
  () => postApiProjectpriorities200Schema,
);
